import ImageSizes from "./ImageSizes";

// Based on https://dev.azure.com/workleap/WorkleapPlatform/_git/workleap-platform?path=/libs/imageprocessing.contracts/src/Workleap.ImageProcessing.Common/MemberAvatarSize.cs
enum WorkleapMemberAvatarImageSize {
    XXSmall = "16",
    XSmall = "24",
    Small = "32",
    XMedium = "48",
    Medium = "64",
    Large = "96",
    XLarge = "224"
}

export const mapOvImageSizeToWorkleapMemberAvatarSize = (size?: ImageSizes): WorkleapMemberAvatarImageSize | null => {
    switch (size?.toString()) {
        case ImageSizes.XSmall:
            return WorkleapMemberAvatarImageSize.XSmall;
        case ImageSizes.Small:
            return WorkleapMemberAvatarImageSize.Small;
        case ImageSizes.XMedium:
            return WorkleapMemberAvatarImageSize.XMedium;
        case ImageSizes.Medium:
            return WorkleapMemberAvatarImageSize.Medium;
        case ImageSizes.XLarge:
            return WorkleapMemberAvatarImageSize.XLarge;
        case ImageSizes.XXLarge:
            return WorkleapMemberAvatarImageSize.XLarge;
        default:
            return null;
    }
};

export default WorkleapMemberAvatarImageSize;

